import debug from 'debug';
import { HelperCore } from './dependencies';

debug.disable();
if(!HelperCore.IS_PROD){
  debug.enable(`assistant:*`);
}
export default function createDebug(moduleName) {
  return debug(`assistant:${moduleName}`);
};